import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../../../utils/useDidMountEffect";
import apiUser from "../../../../../apiUser";
import Checkbox from "../../../../../componentsReusable/Checkbox";
import {Label} from "reactstrap";
import useAfterUpdateEffect from "../../../../../utils/useAfterUpdateEffect";
import {xor} from "lodash";
import Select from "../../../../../componentsReusable/Select";
import LoadingSpinner from "../../../../LoadingSpinner/LoadingSpinner";
import {useTecRmi} from "../../../../../contexts/TecRmiContext";

const gearBoxCodes = {
  65: 'Automatyczna skrzynia biegów',
  77: 'Mechaniczna skrzynia biegów',
  81: 'Automatyczna skrzynia biegów',
}

const GearBoxSelect = (props) => {
  const { getApiPrimaryParams } = useTecRmi()
  const [gearBoxCode, setGearBoxCode] = useState(props.value)
  const [possibleGearBoxCodes, setPossibleGearBoxCodes] = useState([])

  useDidMountEffect(() => {
    apiUser.tecRmi.maintenance.possibleGearboxCodes({
      ...getApiPrimaryParams(),
      KindOfVehicleTreeId: 3,
    })
      .then(res => {
        setPossibleGearBoxCodes(res.data)
      })
  })

  useAfterUpdateEffect(() => {
    props.onChange(gearBoxCode || null)
  }, [gearBoxCode])

  return <Select
    isClearable
    placeholder={'Filtruj rodzaj skrzyni biegów...'}
    onChange={setGearBoxCode}
    options={possibleGearBoxCodes.map(gearBoxCode => ({
      label: gearBoxCodes[gearBoxCode],
      value: gearBoxCode,
    }))}
    value={gearBoxCode}
  />
}

const equipmentFiltersTranslate = {
  1001: 'Długi okres przydatności',
  1002: 'Filtr cząstek',
  1003: 'Start Stop System',
  1004: 'Klimatyzacja',
  1005: 'Sprzęg holowniczy',
  1006: 'AddBlue',
  1007: 'Dach przesuwny',
  1008: 'Reflektory ksenonowe',
}

const Filters = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [loading, setLoading] = useState(true)
  const [possibleFilters, setPossibleFilters] = useState()
  const [equipmentFilter, setEquipmentFilter] = useState(props?.value?.equipmentFilter?.map(equipmentFilter => equipmentFilter.KindOfFilter) ?? [])
  const [kindOfGearBox, setKindOfGearBox] = useState(props?.value?.kindOfGearBox)

  useDidMountEffect(() => {
    apiUser.tecRmi.maintenance.possibleCooGroupFilterParameters({
      ...getApiPrimaryParams(),
      KindOfVehicleTreeId: 3,
    })
      .then(res => {
        setPossibleFilters(res.data)
      })
      .finally(() => setLoading(false))
  })

  useAfterUpdateEffect(() => {
    props.onFiltersChange({
      kindOfGearBox,
      equipmentFilter: equipmentFilter.map(equipmentFilterId => ({
        FilterValue: true,
        KindOfFilter: equipmentFilterId,
      }))
    })
  }, [equipmentFilter, kindOfGearBox])

  const toggleEquipmentFilter = (equipmentFilterId) => setEquipmentFilter(xor(equipmentFilter, [equipmentFilterId]))

  if(loading){
    return <LoadingSpinner />
  }

  return <div>
    {possibleFilters?.IsFilterByGearBoxCodePossible && <GearBoxSelect
      onChange={setKindOfGearBox}
      value={kindOfGearBox}
    />}
    {possibleFilters?.PossibleEquipmentFilter?.map(equipmentFilterId => <div className="d-flex align-items-center cursor-pointer mt-2" key={equipmentFilterId.toString()} onClick={() => toggleEquipmentFilter(equipmentFilterId)}>
      <Checkbox checked={equipmentFilter.includes(equipmentFilterId)} />
      <Label className="ml-2 mb-0">{equipmentFiltersTranslate[equipmentFilterId]}</Label>
    </div>)}
  </div>;
};

Filters.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
};

export default Filters;